import React from 'react';
import cx from 'classnames';
// util
import renderAsBackgroundImage from '~/libs/server/utils/renderAsBackgroundImage';

// components
import { UnderlinedText } from '@zola/zola-ui/src/components/UnderlinedText';
import ImageSection from '~/components/ui/ImageSection';
import { bgColorOption } from '~/components/ui/ImageSection/types';

// styles
import imageSectionStyles from '~/components/ui/ImageSection/_imageSection--shared.module.less';
import styles from './AllYourGiftsImageSection.module.less';

const AllYourGiftsImageSection: React.FC = () => {
  const underlinedTextSettings = {
    borderTopLeftRadius: '25%',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    borderTopRightRadius: '0',
  };
  const renderText = () => (
    <div className={imageSectionStyles.dek}>
      We’re the{' '}
      <UnderlinedText color="teal" {...underlinedTextSettings}>
        only
      </UnderlinedText>{' '}
      store with gifts and experiences from over 800 top brands, plus honeymoon funds. We add{' '}
      <a href="/shop/collection/new-arrivals" rel="noreferrer noopener">
        new arrivals
      </a>{' '}
      weekly and make it easy to{' '}
      <a href="/wedding-registry/apps" rel="noreferrer noopener">
        add gifts from other stores
      </a>{' '}
      to your Zola registry, so guests can see all your gifts on one page.
    </div>
  );
  return (
    <ImageSection
      headerTag="h2"
      backgroundColor={bgColorOption.lightGray}
      title={<div className={imageSectionStyles.title}>All Your Gifts In One Place</div>}
      textPosition="right"
      borderBottom
      imageContents={
        <>
          <div className={cx(styles.secondaryImage)}>
            <span role="img" aria-label="custom photo background save the date card" />
          </div>
          {renderAsBackgroundImage({
            selector: `.${styles.secondaryImage}`,
            backgroundImageName: 'registry_benefits_all_gifts',
            directory: 'WeddingRegistryBenefitsLP/allYourGifts',
            filetype: ['png', 'png', 'png'],
          })}
        </>
      }
      secondaryContents={renderText()}
    />
  );
};

export default AllYourGiftsImageSection;
